import styled from 'styled-components'

export const ListScrollArea = styled.div<{ $maxHeight: string }>`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: ${({ $maxHeight }) => $maxHeight};
  overflow-y: auto;
  width: 100%;
  padding: 1rem;
  border: 1px solid ${(p) => p.theme.colorDividerDefault};
  border-radius: 0.5rem;
  background: ${(p) => p.theme.colorSurface1};
`

export const ListItem = styled.div`
  cursor: pointer;
  width: 100%;
  padding: 0.5rem 0 0.5rem 1rem;
  border-radius: 0.25rem;
  transition: background-color 0.13s ease-in;

  &:hover {
    background-color: ${(p) => p.theme.inputActiveBackground};
    box-shadow: ${(p) => p.theme.shadowInputActive};
  }
`

export const ListStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 4rem;
  width: 100%;
`
